import React, { useRef, useEffect, useState } from 'react';
import styles from './LandingPage.module.css';
import { useNavigate } from 'react-router-dom';

const ARTISTS = [
  { id: 'chan69x', url: 'https://instagram.com/chan69x' },
  { id: 'salemhu.tattoo', url: 'https://instagram.com/salemhu.tattoo' },
  { id: 'dacapo.tat', url: 'https://instagram.com/dacapo.tat' },
  { id: 'garconenstock', url: 'https://instagram.com/garconenstock' },
  { id: 'sesame.tattoo', url: 'https://instagram.com/sesame.tattoo' },
  { id: '0blackjelly0', url: 'https://instagram.com/0blackjelly0' },
  { id: 'autokinkmatink', url: 'https://instagram.com/autokinkmatink' },
  { id: 'loesuy.tat', url: 'https://instagram.com/loesuy.tat' },
  { id: 'pan.tatts', url: 'https://instagram.com/pan.tatts' },
  { id: 'hyoan_tattoo', url: 'https://instagram.com/hyoan_tattoo' },
  { id: '_rhoume', url: 'https://instagram.com/_rhoume' },
  { id: 'max_brazos_ttt', url: 'https://instagram.com/max_brazos_ttt' },
  { id: 'errance.tttttt', url: 'https://instagram.com/errance.tttttt' },
];
// 의류 페이지 - 현재 미사용
// eslint-disable-next-line no-unused-vars
const CLOTHES = [
  { id: 'gnegnegne.atelier', url: 'https://instagram.com/gnegnegne.atelier' },
];

// 우측 화살표 점 좌표 생성 함수
function getVerticalTextPoints() {
  const points = [];
  const canvasWidth = 45;
  const canvasHeight = 45;

  const centerX = canvasWidth / 2;
  const centerY = canvasHeight / 2;

  // 화살표 크기 설정
  const arrowLength = 20;
  const arrowHeadSize = 10;

  // 화살표 본체 (가로선)
  for (let x = centerX - arrowLength / 2; x <= centerX + arrowLength / 2; x += 0.4) {
    points.push({ x: x, y: centerY });
  }

  // 화살표 머리 (위쪽 대각선)
  for (let i = 0; i <= arrowHeadSize; i += 0.4) {
    points.push({
      x: centerX + arrowLength / 2 - i,
      y: centerY - i
    });
  }

  // 화살표 머리 (아래쪽 대각선)
  for (let i = 0; i <= arrowHeadSize; i += 0.4) {
    points.push({
      x: centerX + arrowLength / 2 - i,
      y: centerY + i
    });
  }

  return points;
}

const VERTICAL_TEXT_POINTS = getVerticalTextPoints();

// 기기 성능에 따른 점 개수 조정
function getOptimalDotCount() {
  return 200; // 30x30 크기에 맞게 점 개수 축소
}

const DOT_COUNT = getOptimalDotCount();

// ASCII 아트 스타일 텍스트
const ASCII_TEXT = "GNEGNEGNE";
const OUTLINE_PULSE_COUNT = 3;
const OUTLINE_PULSE_DELAY_SECONDS = 0.55;
const ARTIST_LIST_TITLES = ['TATTOO', 'TATOUAGE', '타투'];
const GUEST_INQUIRY_TITLES = ['TATTOO GUEST INQUIRY', 'DEMANDE GUEST TATOUAGE', '타투 게스트 문의'];

// 애니메이션 타입 (떨림 효과만)
const ANIMATION_TYPES = ['asciiJitter'];

export default function LandingPage() {
  const canvasRef = useRef();
  const [dots, setDots] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const titleRef = useRef();
  const [mode, setMode] = useState('scatter');
  const [hasClicked, setHasClicked] = useState(false);
  const scatterIntervalRef = useRef(null);
  const navigate = useNavigate();
  const [artistListTitleIndex, setArtistListTitleIndex] = useState(0);

  // 타이틀 애니메이션 상태
  const [titleAnimation, setTitleAnimation] = useState('asciiJitter');

  // 2초마다 랜덤 애니메이션 전환
  useEffect(() => {
    const animationInterval = setInterval(() => {
      const randomIndex = Math.floor(Math.random() * ANIMATION_TYPES.length);
      setTitleAnimation(ANIMATION_TYPES[randomIndex]);
    }, 2000);

    return () => clearInterval(animationInterval);
  }, []);

  useEffect(() => {
    const titleInterval = setInterval(() => {
      setArtistListTitleIndex(prev => (prev + 1) % ARTIST_LIST_TITLES.length);
    }, 1800);

    return () => clearInterval(titleInterval);
  }, []);

  // ClientPage와 동일한 점 애니메이션 구조
  useEffect(() => {
    setDots(Array.from({ length: DOT_COUNT }).map(() => ({
      x: Math.random() * 45,
      y: Math.random() * 45,
      targetX: Math.random() * 45,
      targetY: Math.random() * 45,
    })));
  }, []);

  useEffect(() => {
    if (mode === 'text') {
      setDots(prev => prev.map((dot, i) => {
        // 모든 글자에 균등하게 점들을 배치
        const pointIndex = Math.floor((i / prev.length) * VERTICAL_TEXT_POINTS.length);
        const pt = VERTICAL_TEXT_POINTS[pointIndex];
        return { ...dot, targetX: pt.x, targetY: pt.y };
      }));
    }
  }, [mode]);

  useEffect(() => {
    let raf;
    function animate() {
      setDots(prev => prev.map((dot, i) => {
        const lerp = (a, b, t) => a + (b - a) * t;
        let targetX = dot.targetX;
        let targetY = dot.targetY;
        if (mode === 'scatter') {
          if (Math.random() < 0.03) { // 0.08에서 0.03으로 감소 (더 느리게)
            targetX = Math.random() * 45;
            targetY = Math.random() * 45;
          }
        } else if (mode === 'text') {
          // text 모드에서 더 강렬한 흩뿌리기 효과
          if (Math.random() < 0.05) { // 5% 확률로 강렬한 랜덤 이동
            const pointIndex = Math.floor((i / prev.length) * VERTICAL_TEXT_POINTS.length);
            const pt = VERTICAL_TEXT_POINTS[pointIndex];
            targetX = pt.x + (Math.random() - 0.5) * 6; // ±3픽셀 범위
            targetY = pt.y + (Math.random() - 0.5) * 6; // ±3픽셀 범위
          }
        }
        return {
          ...dot,
          x: lerp(dot.x, targetX, mode === 'scatter' ? 0.08 : 0.18), // scatter 모드에서는 더 느리게
          y: lerp(dot.y, targetY, mode === 'scatter' ? 0.08 : 0.18),
          targetX,
          targetY,
        };
      }));
      raf = requestAnimationFrame(animate);
    }
    raf = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(raf);
  }, [mode]);

  // ClientPage와 동일한 캔버스 렌더링
  useEffect(() => {
    const ctx = canvasRef.current.getContext('2d');
    ctx.clearRect(0, 0, 45, 45);
    ctx.fillStyle = '#111';
    dots.forEach(dot => {
      ctx.globalAlpha = 1;
      ctx.beginPath();
      ctx.arc(dot.x, dot.y, 0.75, 0, 2 * Math.PI);
      ctx.fill();
    });
    ctx.globalAlpha = 1;
  }, [dots]);

  // 컴포넌트 언마운트 시 모든 리소스 정리
  useEffect(() => {
    return () => {
      // 모든 인터벌 정리
      if (scatterIntervalRef.current) {
        clearInterval(scatterIntervalRef.current);
        scatterIntervalRef.current = null;
      }

      // 상태 초기화
      setDots([]);
    };
  }, []);

  // 클릭 핸들러
  const handleCircleClick = () => {
    if (!hasClicked) {
      setMode('text');
      setHasClicked(true);
    } else if (mode === 'text') {
      navigate('/login');
    }
  };

  return (
    <div className={styles.wrapper}>
      {/* 섹션2: 원 + 점 (우측 하단 고정) */}
      <div
        className={styles.circleSection}
        onClick={handleCircleClick}
        style={{ cursor: 'pointer' }}
      >
        <canvas
          ref={canvasRef}
          width={45}
          height={45}
          className={styles.rectangleCanvas}
        />
      </div>

      {/* Center Wrapper for Header and List */}
      <div className={styles.centerWrapper}>
        {/* Header Section */}
        <div className={styles.header}>
          <div
            className={`${styles.mainTitle} ${styles[titleAnimation]}`}
            data-text={ASCII_TEXT}
          >
            {Array.from({ length: OUTLINE_PULSE_COUNT }).map((_, index) => (
              <span
                key={`outline-pulse-${index}`}
                aria-hidden="true"
                className={styles.logoOutlinePulseLayer}
                style={{ animationDelay: `${index * OUTLINE_PULSE_DELAY_SECONDS}s` }}
              >
                {ASCII_TEXT}
              </span>
            ))}
            {(titleAnimation === 'asciiJitter' || titleAnimation === 'chromaticAscii')
              ? ASCII_TEXT.split('').map((char, i) => (
                <span
                  key={i}
                  className={titleAnimation === 'asciiJitter' ? styles.asciiChar : styles.chromaticChar}
                  style={{ animationDelay: `${i * 0.05}s` }}
                >
                  {char}
                </span>
              ))
              : ASCII_TEXT
            }
          </div>
        </div>

        <div className={styles.artistListSection}>
          <div className={styles.scrollTitle}>
            {ARTIST_LIST_TITLES[artistListTitleIndex]}
          </div>

          {/* Vertical Infinite Scroll List */}
          <div
            className={styles.scrollContainer}
            style={{ height: `calc(${ARTISTS.length} * (0.75rem + 6.6px))` }}
          >
            <div className={styles.scrollContent}>
              {/* Duplicate list for seamless loop */}
              {[...ARTISTS, ...ARTISTS].map((artist, index) => (
                <a
                  key={`${artist.id}-${index}`}
                  href={artist.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.scrollItem}
                >
                  @{artist.id}
                </a>
              ))}
            </div>
          </div>

          <a
            className={styles.guestInquiryMenu}
            href="/guest-conditions"
            target="_blank"
            rel="noopener noreferrer"
          >
            {GUEST_INQUIRY_TITLES[artistListTitleIndex]}
          </a>

          <div className={styles.labMenu}>
            ## Gggg ## comming soon
          </div>

          <div className={styles.historyMenu}>
            <div>HISTORY</div>
            <div className={styles.historyLineIndented}>) EXPOSITION</div>
            <div className={styles.historyLineDeepIndented}>
              {':: < Mokyoktang > Cha ji hoon 04.06 -08.06 2025'}
            </div>
            <div className={styles.historyAddress}>
              4 RUE DUNOIS 75013 PARIS
            </div>
            <div className={styles.historySinceText}>SINCE 2023</div>
          </div>
        </div>
      </div>
    </div>
  );
}
